module.exports = "/images/avatar1.jpg?3c1d3e6222ef6c87202c182c419956a9";